module.exports = __webpack_public_path__ + "img/payments.daily.57d62e38.png";